import BaseResource from './BaseResource'

export default class Asns extends BaseResource {
  static endpoint = '/api/v1/asns' // /logistics
}
